import React from 'react'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import AddNote from '../../CreateTimesheet/AddNote/AddNote'
import FamilyCard from '../../CreateTimesheet/FamilyCard/FamilyCard'
import {eachDayOfInterval, endOfMonth, format, startOfToday, parse, endOfWeek, startOfWeek, startOfMonth} from 'date-fns'
import CreateTimesheetAreYouSure from '../../CreateTimesheet/CreateTimesheetAreYouSure/CreateTimesheetAreYouSure'
import { createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime } from '../../Calendar/calendarFunctions'
import AutoGeneratedFamilyCard from './AutoGeneratedFamilyCard/AutoGeneratedFamilyCard'


const AutoPopulatedTimesheet = (props) => {
    const [families, setFamilies] = React.useState([])
    const [finalWarning, setFinalWarning] = React.useState(false)
    const [note, setNote] = React.useState('')
    const [notesOpen, setNotesOpen] = React.useState(false)
    const [estimatedPay, setEstimatedPay] = React.useState(0)
    const [listOfFamiliesForTeachers, setListOfFamiliesForTeachers] = React.useState([])
    const [incomplete, setIncomplete] = React.useState(false)
    const [monthNumber, setMonthNumber] = React.useState(0)
    const [cancellationWarning, setCancellationWarning] = React.useState(false)
    const [calendarEvents, setCalendarEvents] = React.useState([])
    const [calendarDaysWithEvents ,setCalendarDaysWithEvents] = React.useState({})
    const [currentMonth, setCurrentMonth] = React.useState(format(startOfToday(), 'MMMM yyyy'))
    const [daysOfTheDisplayedMonth, setDaysOfTheDisplayedMonth] = React.useState(eachDayOfInterval({start: startOfMonth(parse(currentMonth, 'MMMM yyyy', new Date())), end: endOfMonth(parse(currentMonth, 'MMMM yyyy', new Date()))}))
    const [familiesEventsObject, setFamiliesEventsObject] = React.useState({})


    const myToken = localStorage.getItem('token')
    const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}


    let d = new Date()
    let theYear = d.getFullYear()
    let theMonthNumber = d.getMonth()

    React.useEffect(() => {
        const getTeachersFamilies = async () => {
            let fixedName = encodeURIComponent(props.userData.Name.trim())
            //let REPLACEWITHFIXEDNAME = 'Andi%20Bonato'
            let res = await axios.get(`${baseUrl}/teachersfamilies/${props.userData.TeacherID}`, myHeader)
            setListOfFamiliesForTeachers(res.data)
        }
        getTeachersFamilies()
        calculateEstimatedPay()
        createDateSettings()
        getTeachersCalendarEvents()
    },[])

    React.useEffect(() => {
        if(families.length > 0) {
            if(document.getElementById('create-timesheet__submit-btn')) {
                document.getElementById('create-timesheet__submit-btn').style.backgroundColor = "rgba(0, 128, 0, 0.747)"
            }
        } else {
            if(document.getElementById('create-timesheet__submit-btn')) {
                document.getElementById('create-timesheet__submit-btn').style.backgroundColor = 'rgba(128, 128, 128, 0.336)'
            }
        }
        // if(props.families) {
        //     setFamilies(props.families)
        // }
        calculateEstimatedPay()

        //CHECK IF EVERYTHING IS FILLED OUT
        for(let i = 0; i < families.length; i++) {
            let theFamily = families[i]
            for(let i = 0; i < theFamily.lessons.length; i++) {
                if(theFamily.lessons[i].studentName === '' || theFamily.lessons[i].lessonLength === 0 || theFamily.lessons[i].date === "") {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }    
            }
            for(let i = 0; i < theFamily.cancellations.length; i++) {
                if(theFamily.cancellations[i].cancellor === 'teacher') {
                    setCancellationWarning(true)
                } else {
                    setCancellationWarning(false)
                }
                if(theFamily.cancellations[i].student === '' || theFamily.cancellations[i].cancellor === '0' || (theFamily.cancellations[i].lessonLength === 0 && theFamily.cancellations[i].cancellor === "student less than 24hrs") || theFamily.cancellations[i].date === "") {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }
            }
            for( let i = 0; i < theFamily.extras.length; i++) {
                if(theFamily.extras[i].description === '' || theFamily.extras[i].amount === 0) {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }
            }
        }
    }, [families])

    React.useEffect(() => {
        //console.log(calendarEvents)
        createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime(daysOfTheDisplayedMonth, calendarEvents, setCalendarDaysWithEvents)
    }, [calendarEvents])

    React.useEffect(() => {
        organizeTheTimesheet()
    }, [calendarDaysWithEvents])

    const organizeTheTimesheet = () => {
        let multiFamilyObject = {}
        let totalMinutesTaught = 0
        Object.keys(calendarDaysWithEvents).map((thing) => {
            for(let j = 0; j < calendarDaysWithEvents[thing].events.length; j++) {
                if(!calendarDaysWithEvents[thing].events[j].isPendingOffer) {
                    totalMinutesTaught = totalMinutesTaught + calendarDaysWithEvents[thing].events[j].lessonLength
                }
                if(multiFamilyObject[calendarDaysWithEvents[thing].events[j].familyName]){
                   if(!calendarDaysWithEvents[thing].events[j].isPendingOffer){
                    multiFamilyObject[calendarDaysWithEvents[thing].events[j].familyName].push(calendarDaysWithEvents[thing].events[j])
                   }
                } else {
                   if(!calendarDaysWithEvents[thing].events[j].isPendingOffer){
                    multiFamilyObject[calendarDaysWithEvents[thing].events[j].familyName] = [calendarDaysWithEvents[thing].events[j]]
                   }
                }
            }
        })
        setEstimatedPay(((totalMinutesTaught/60) * Number(props.rate)))
        setFamiliesEventsObject(multiFamilyObject)
    }

    const getTeachersCalendarEvents = () => {
        axios.get(`${baseUrl}/calendar/teacher/${props.userData.TeacherID}`)
        .then((res) => setCalendarEvents(res.data))
        .catch((err) => console.log(err))
    }

    const createDateSettings = () => {
        let d = new Date()
        let month = d.getMonth()
        let day = d.getDate()
        let theYear = d.getFullYear()
        let adjustedMonth;
        if(day < 15) {
            if(month !== 0) {
                adjustedMonth = month
            } else if (month === 0) {
                adjustedMonth = 12
            } else {
                adjustedMonth = month + 1
            }
        } else {
            adjustedMonth = month  + 1
        }
        setMonthNumber(adjustedMonth)
    }

    const calculateEstimatedPay = () => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < families.length; i++) {
            let fam = families[i]
            for(let i = 0; i < fam.lessons.length; i++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
            }
            for(let i = 0; i < fam.cancellations.length; i++) {
                if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                }
            }
            for(let i = 0; i < fam.extras.length; i++) {
                allExtras = Number(allExtras) + Number(fam.extras[i].amount)
            }
        }
        setEstimatedPay(((minutesTaught/60) * Number(props.rate)) + allExtras)
    }

    const tryToSubmitTimesheet = () => {
            setFinalWarning(true)
    }

    const submitTimesheet = async () => {
        let teachersTime = {
            timesheetId: Math.random().toString(16).slice(2),
            teacherId: props.userData.TeacherID,
            teacherName: props.userData.Name,
            families: families,
            status: 'submitted',
            note: note,
            submitDate: new Date(),
            monthYear: `${props.month}/${props.myYear}`,
            teacherRate: props.rate,
            school: props.userData.School,
            email: props.userData.Email,
            monthNumber: monthNumber,
            year: props.myYear

        }
        setFinalWarning(false)
        axios.post(`${baseUrl}/teachertimesheet`, {
            teacherTimesheet: teachersTime
        }, myHeader)
        .then((res) => {
            props.pushNewTimesheetToTimesheets(res.data)
            props.setOpenUpTheTimesheet(false)
            props.setThankYouForSubmitting(true)
            props.setTryingToSubmitTimesheet(false)
        })
        .catch((err) => {
            console.log(err)
            console.log('oops there was an error')
        })
    }

    const cancelOutOfTimesheetProcess = () => {
        props.setTryingToSubmitTimesheet(false)
        props.setOpenUpTheTimesheet(false)
    }

    return(
        <div className="create-timesheet-wrapper">
            <div className="create-timesheet">
                {finalWarning && <CreateTimesheetAreYouSure submitTimesheet={submitTimesheet} setFinalWarning={setFinalWarning} />}
                {notesOpen && <AddNote setNotesOpen={setNotesOpen} note={note} setNote={setNote} />}
                <div className="another-x-wrapper">
                    <h3 className="close-create-timesheet-x" onClick={() => cancelOutOfTimesheetProcess()}>X</h3>
                </div>
                <h1>Create Timesheet</h1>
                <h2>{props.month} {props.myYear}</h2>
                <div className="family-card-section">
                    {Object.keys(familiesEventsObject).map((name, index) => (
                        <AutoGeneratedFamilyCard key={index} family={familiesEventsObject[name]} name={name} />
                    ))}
                </div>
                <div className="create-timesheet-bottom-sections">
                    {cancellationWarning && note === '' && <div className='create-timesheet__note-warning'>Explain cancellation w/ note</div>}
                    <div className="create-timesheet__add-note" style={cancellationWarning && note === '' ? {animation: "grow 1.4s linear infinite"} : {color: "#000"}} onClick={() => setNotesOpen(true)}>+ Note</div>
                    {note !== '' && <div className="create-timesheet-pencil"></div>}
                    <h3 className="create-timesheet__estimated-pay">Estimate Pay: ${estimatedPay}</h3>
                    <div>
                        <div className="create-timesheet__submit-timesheet" onClick={() => tryToSubmitTimesheet()} id="create-timesheet__submit-btn">Submit Timesheet</div>
                        {incomplete && <p style={{color: "red"}}>Please Fill Out Everything</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AutoPopulatedTimesheet;